import { BoxProps, ButtonProps, CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const ButtonOutsideArea = {
  display: 'none',
};

export const FlexContainer = (): CSSObject => ({
  px: ['2.5', null, null, '0'],
  h: 'unset',
});

export const BoxWrapper: BoxProps = {
  pr: '0',
};

export const buttonLogInProps: ButtonProps = {
  variant: 'solid',
  height: '46px',
  textTransform: 'uppercase',
  fontWeight: 'black',
  fontSize: 'xs',
};

export const buttonSignUpProps: CustomButtonProps = {
  variant: 'secondary',
  height: '46px',
  textTransform: 'uppercase',
  fontWeight: 'black',
  fontSize: 'xs',
};

export const buttonQuickAccessProps: CustomButtonProps = {
  variant: 'primaryAccess',
  height: '46px',
  p: '2.5',
  sx: {
    '.btn-span': {
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      mr: '1',
      mt: '0.5',
    },
    '.span-balance': {
      fontSize: 'sm',
      lineHeight: '14px',
      color: 'beta.300',
      mb: '0.5',
    },
    '.span-bonus': {
      fontFamily: 'accent',
      fontSize: '2xs',
      lineHeight: '10px',
      color: 'beta.300',
      alignSelf: 'start',
    },

    'svg:not(.chevron-icon)': {
      pos: 'relative',
      top: '0.5',
      mr: '0.5',
    },
    '.chevron-icon': {
      pos: 'absolute',
      right: '1.5',
      top: '0',
      bottom: '0',
      margin: 'auto 0',
      color: 'beta.300',
      filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
    },
    '&&[aria-expanded="true"]': {
      '.chevron-icon': { transform: 'rotate(180deg)', color: 'blackAlpha.700' },
      borderBottomRadius: 'none',
      zIndex: 'dropdown',
      '.span-balance': {
        fontSize: 'sm',
        lineHeight: '14px',
        color: 'blackAlpha.700',
        mb: '0.5',
      },
      '.span-bonus': {
        fontFamily: 'accent',
        fontSize: '2xs',
        lineHeight: '10px',
        color: 'blackAlpha.700',
        alignSelf: 'start',
      },
    },
  },
};

export const buttonBetsProps: ButtonProps = {
  variant: 'solid',
  color: 'blackAlpha.800',
  height: '46px',
  padding: '0px 5px',
  pt: '12px',
  pb: '13px',
  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '1.5',
    },
    '.span-bet': {
      fontWeight: 'black',
      fontSize: '2xs',
      fontFamily: 'accent',
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.6)',
    },
    '.span-bet-count': {
      fontWeight: 'black',
      fontSize: 'sm',
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.6)',
    },
  },
};

export const buttonBetSlipProps: ButtonProps = {
  variant: 'solid',
  color: 'blackAlpha.800',
  height: '46px',
  padding: '0px 5px',
  pt: '12px',
  pb: '13px',

  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '1.5',
    },
  },
};

export const IconButtonMenu = (): CSSObject => ({
  bg: 'transparent',
  color: 'white',
  boxSize: '8',
  ml: '-1.5',

  '& svg': {
    boxSize: '8',
  },
});

export const FlexLeftGroup: CSSObject = {
  gap: '1.5',
  justifyContent: 'flex-start',
  alignItems: 'center',
};

export const buttonQuickAccess: ButtonProps = {
  variant: 'secondary',
};

export const ButtonGroupBets: CSSObject = {
  gap: '0.5',

  '> .chakra-button ~ .chakra-button': {
    marginInlineStart: 0,
  },
  '>*:first-of-type:not(:last-of-type)': {
    borderRightRadius: 'md',
  },
  '>*:not(:first-of-type):last-of-type': {
    borderLeftRadius: 'md',
  },
};

export const ButtonBetSlip: CSSObject = {
  ml: '0',
};

export const ButtonGroup: CSSObject = {
  gap: '1',
};

export const LinkLogo: CSSObject = {
  display: ['block', null, null, 'none'],
  ml: '-2',
};

export const TextButton: CSSObject = {
  fontWeight: 'black',
  fontSize: '2xs',
  fontFamily: 'accent',
  color: 'blackAlpha.800',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.6)',
};

export const TextButtonNumber: CSSObject = {
  fontWeight: 'black',
  fontSize: 'sm',
  color: 'blackAlpha.800',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.6)',
};
